package fr.frux.feature.treedetail.site

import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.SnackbarResult
import androidx.compose.runtime.Composable
import fr.frux.core.designsystem.components.SnackbarMessageEffect
import fr.frux.core.designsystem.error.userMessage
import fr.frux.feature.treedetail.resources.Res
import fr.frux.feature.treedetail.resources.treedetail_site_snackbar_attached
import fr.frux.feature.treedetail.resources.treedetail_site_snackbar_detached
import fr.frux.feature.treedetail.resources.treedetail_site_snackbar_undo
import fr.frux.feature.treedetail.resources.treedetail_site_snackbar_undone
import org.jetbrains.compose.resources.stringResource

/**
 * Snackbars du lien au lieu, même patron que `IdentityMessageEffect`. Le message est consommé
 * avant l'annulation : `undoAttach()` lit le lieu dans l'état, pas le message, et son propre
 * message « Rattachement annulé » ne doit pas être effacé par cette consommation.
 */
@Composable
internal fun SiteLinkMessageEffect(
    ui: TreeSiteUi,
    controller: TreeSiteLinkController,
    snackbarHostState: SnackbarHostState,
) {
    val message = ui.message
    val text =
        when (message) {
            is SiteLinkMessage.Attached -> {
                stringResource(Res.string.treedetail_site_snackbar_attached, message.siteName)
            }

            SiteLinkMessage.Undone -> {
                stringResource(Res.string.treedetail_site_snackbar_undone)
            }

            SiteLinkMessage.Detached -> {
                stringResource(Res.string.treedetail_site_snackbar_detached)
            }

            is SiteLinkMessage.Failed -> {
                message.error.userMessage()
            }

            null -> {
                null
            }
        }
    val attached = message is SiteLinkMessage.Attached
    SnackbarMessageEffect(
        trigger = message,
        message = text,
        snackbarHostState = snackbarHostState,
        actionLabel = if (attached) stringResource(Res.string.treedetail_site_snackbar_undo) else null,
        duration = if (attached) SnackbarDuration.Long else SnackbarDuration.Short,
    ) { result ->
        controller.consumeMessage()
        if (result == SnackbarResult.ActionPerformed) controller.undoAttach()
    }
}
